import classNames from 'classnames';

import { Button, ButtonGroup } from '@revelio/ui';

import styles from './FilterSelectFooter.module.css';

export const FilterSelectFooter = ({
  onClose,
  onClearSelections,
  onAdd = () => undefined,
  addLabel = 'Add',
  isAddDisabled = false,
  onBack,
  loading = false,
}: {
  onClose: () => void;
  onClearSelections?: () => void;
  onAdd?: () => void;
  isAddDisabled?: boolean;
  addLabel?: string;
  onBack?: () => void;
  loading?: boolean;
}) => {
  return (
    <div className={styles.footer}>
      <div className={styles.footerActions}>
        {onClearSelections && (
          <Button
            variant="ghost"
            size="sm"
            className={styles.fontXs}
            color="destructive"
            onClick={onClearSelections}
          >
            Clear selections
          </Button>
        )}
        {onBack && (
          <Button
            variant="link"
            size="sm"
            className={classNames(styles.fontXs, styles.linkAction)}
            onClick={onBack}
          >
            Back
          </Button>
        )}
      </div>
      <ButtonGroup style={{ gap: 'var(--ui-spacing-4)' }}>
        <Button
          variant="link"
          size="sm"
          className={classNames(styles.fontXs, styles.linkAction)}
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button
          data-testid="filter-popover-submit"
          disabled={isAddDisabled}
          color="primary"
          variant="default"
          size="sm"
          className={styles.fontXs}
          onClick={onAdd}
          loading={loading}
        >
          {addLabel}
        </Button>
      </ButtonGroup>
    </div>
  );
};
